import { api } from 'common';

import { switchBlockDocumentationMarkdown } from './documentation';
import { CodeMirrorLanguageType } from '../../../../Code/types';
import { SharedFunctionBlockFormFields } from '../../ConfigFields/JavaScriptBlock/FormFields';
import { type BlockConfigProps } from '../../types';

export const switchConfig: BlockConfigProps<api.FlowDefinition.SwitchBlock['config']> = {
  nodeHandles: [
    { type: 'target' },
    { type: 'source', id: 'true' },
    { type: 'source', id: 'false' },
  ],
  defaultLabelPrefix: 'conditional',
  defaultConfig: {
    fn: `/**
 * You can refer to upstream block's
 * output by typing the block's name.
 * Examples:
 *
 * return block1.data > 10;
 * return block2.data.includes('abc');
 */
return true;
`,
    switchResultType: 'boolean',
  },
  configFields: {
    getLanguageFieldValues: (config) => {
      return {
        [CodeMirrorLanguageType.JavaScriptAndNodeFields]: [config.fn],
      };
    },
    schema: api.FlowDefinition.SwitchBlockConfigSchema,
    FormFields: SharedFunctionBlockFormFields,
  },
  documentationMarkdown: switchBlockDocumentationMarkdown,
};
